function NotFound() {
  return (
    <div>403</div>
  );
}

export default NotFound;
